(() => {
  /**
   * Fly-out navigation (Responzive)
   *  - [data-fly-open="menu"|"search"] opens the drawer (Shop trigger, mobile burger, header search icon)
   *  - desktop: hovering/clicking a rail category shows its panel; arrow keys move along the rail
   *  - mobile: tapping a category drills in (track slides); Back returns; Esc walks back out
   *  - search: predictive results rendered by sections/predictive-search-lite.liquid replace the
   *    menu while a term of 2+ characters is typed; clearing restores the menu; submit goes to the
   *    search page with the theme's partial-match form (*term*)
   */
  const root = document.getElementById("fly-drawer");
  if (!root) return;
  // The drawer is rendered inside the header section, whose sticky wrapper (z-index 4) would trap
  // it under the announcement bar (z-index 6). Portal it to <body> so position: fixed is honoured.
  if (root.parentElement !== document.body) document.body.appendChild(root);

  const $ = (sel, el = root) => el.querySelector(sel);
  const $$ = (sel, el = root) => Array.from(el.querySelectorAll(sel));
  const panel = $(".fly__panel");
  const track = $("[data-fly-track]");
  const menu = $("[data-fly-menu]");
  const results = $("[data-fly-results]");
  const resultsInner = $("[data-fly-results-inner]");
  const status = $("[data-fly-results-status]");
  const input = $("[data-fly-search-input]");
  const clearBtn = $("[data-fly-search-clear]");
  const form = $("[data-fly-search]");
  const cats = $$("[data-fly-cat]");
  const panels = $$("[data-fly-panel]");
  const mq = window.matchMedia("(max-width: 991px)");
  const isMobile = () => mq.matches;
  const i18n = {
    searching: root.dataset.flyI18nSearching || "Searching…",
    noResults: root.dataset.flyI18nNoresults || "No results for “%s”",
  };
  const searchBase = root.dataset.flySearchUrl || ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/") + "search";

  let isOpen = false;
  let active = Math.max(0, cats.findIndex((c) => c.classList.contains("is-active")));
  let lastTrigger = null;
  let closeTimer = null;

  // ---------- categories ----------
  function selectCat(i, { drill = false } = {}) {
    if (!cats[i]) return;
    active = i;
    cats.forEach((c, k) => { c.classList.toggle("is-active", k === i); c.setAttribute("aria-selected", k === i ? "true" : "false"); });
    panels.forEach((p, k) => { p.hidden = k !== i; p.classList.toggle("is-active", k === i); });
    if (drill) {
      track.classList.add("is-level-1");
      const back = $("[data-fly-back]");
      if (back) setTimeout(() => back.focus({ preventScroll: true }), 60);
    }
  }
  function goBack() {
    track.classList.remove("is-level-1");
    if (cats[active]) cats[active].focus({ preventScroll: true });
  }

  // ---------- open / close ----------
  function setExpanded(v) {
    document.querySelectorAll("[data-fly-open]").forEach((b) => b.setAttribute("aria-expanded", String(v)));
  }
  function open(mode, trigger) {
    clearTimeout(closeTimer);
    lastTrigger = trigger || document.activeElement;
    root.hidden = false;
    void panel.offsetWidth; // paint the closed transform before the transition starts
    root.classList.add("is-open");
    document.documentElement.classList.add("fly-lock");
    isOpen = true;
    setExpanded(true);
    if (!isMobile()) track.classList.remove("is-level-1");
    setTimeout(() => {
      if (mode === "search") input.focus({ preventScroll: true });
      else (cats[active] || panel).focus({ preventScroll: true });
    }, 80);
  }
  function close() {
    if (!isOpen) return;
    isOpen = false;
    root.classList.remove("is-open");
    setExpanded(false);
    document.documentElement.classList.remove("fly-lock");
    closeTimer = setTimeout(() => {
      root.hidden = true;
      track.classList.remove("is-level-1");
      resetSearch();
    }, 380);
    if (lastTrigger && lastTrigger.focus) lastTrigger.focus({ preventScroll: true });
  }

  // ---------- search ----------
  let timer = null, ctrl = null, lastTerm = "";
  const esc = (s) => String(s).replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));
  function showMenu() {
    results.hidden = true;
    menu.hidden = false;
    resultsInner.innerHTML = "";
    status.textContent = "";
  }
  function resetSearch() {
    if (ctrl) ctrl.abort();
    clearTimeout(timer);
    input.value = "";
    lastTerm = "";
    clearBtn.hidden = true;
    showMenu();
  }
  async function search(term) {
    if (ctrl) ctrl.abort();
    ctrl = new AbortController();
    menu.hidden = true;
    results.hidden = false;
    status.textContent = i18n.searching;
    const url = `${searchBase}/suggest?section_id=predictive-search-lite&q=${encodeURIComponent(term)}` +
      `&resources[type]=product,collection,page,article,query&resources[limit]=6` +
      `&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,vendor,tag,variants.sku`;
    try {
      const res = await fetch(url, { signal: ctrl.signal, credentials: "same-origin" });
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, "text/html");
      const section = doc.querySelector("#shopify-section-predictive-search-lite");
      status.textContent = "";
      if (section && section.innerHTML.trim()) {
        resultsInner.innerHTML = section.innerHTML;
        // the theme's lazy-image snippet leaves the URL in data-src with a {width} placeholder
        resultsInner.querySelectorAll("img").forEach((img) => {
          const src = img.getAttribute("data-src");
          if (src && !img.getAttribute("src")) img.setAttribute("src", src.replace("{width}", "200"));
          img.classList.remove("lazyload", "no-js-hidden");
          img.removeAttribute("loading");
        });
      } else {
        resultsInner.innerHTML = `<div class="search-bar-no-results"><h3>${esc(i18n.noResults.replace("%s", term))}</h3></div>`;
      }
    } catch (e) {
      if (e && e.name === "AbortError") return;
      status.textContent = "";
    }
  }
  input.addEventListener("input", () => {
    const term = input.value.trim();
    clearBtn.hidden = term.length === 0;
    clearTimeout(timer);
    if (term.length < 2) { if (ctrl) ctrl.abort(); lastTerm = ""; showMenu(); return; }
    if (term === lastTerm) return;
    timer = setTimeout(() => { lastTerm = term; search(term); }, 280);
  });
  clearBtn.addEventListener("click", () => { resetSearch(); input.focus(); });
  form.addEventListener("submit", (e) => {
    e.preventDefault();
    const term = input.value.trim();
    if (!term) { input.focus(); return; }
    // same partial-match form the theme's own search submit uses
    window.location.assign(`${searchBase}?type=product&q=${encodeURIComponent("*" + term + "*")}&options%5Bprefix%5D=last`);
  });

  // ---------- events ----------
  document.addEventListener("click", (e) => {
    const opener = e.target.closest("[data-fly-open]");
    if (opener) { e.preventDefault(); open(opener.getAttribute("data-fly-open") || "menu", opener); return; }
    if (!isOpen) return;
    if (e.target.closest("[data-fly-close]")) { e.preventDefault(); close(); return; }
    if (e.target.closest("[data-fly-back]")) { e.preventDefault(); goBack(); return; }
    const cat = e.target.closest("[data-fly-cat]");
    if (cat && root.contains(cat)) {
      const i = Number(cat.dataset.flyCat);
      if (isMobile()) selectCat(i, { drill: true });
      else if (i === active && cat.dataset.flyUrl && cat.dataset.flyUrl !== "#") window.location.assign(cat.dataset.flyUrl);
      else selectCat(i);
    }
  });
  // the theme's header search icon opens the drawer's search (capture: its jQuery handler never runs)
  document.addEventListener("click", (e) => {
    const icon = e.target.closest(".header-search-icon .search-form");
    if (!icon) return;
    e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
    open("search", icon);
  }, true);
  // Hover intent ("menu aim"): moving diagonally from a category toward its panel crosses the
  // categories in between; switching on every mouseenter would swap the panel out from under the
  // pointer. While the pointer is heading for the panel (inside the triangle from it to the
  // panel's left edge) the switch waits; once it stops, or moves along the rail, it happens.
  const panelsWrap = $("[data-fly-panels]");
  const AIM_DELAY = 280;
  let locs = [], aimTimer = null, lastDelayLoc = null;
  root.addEventListener("mousemove", (e) => { locs.push({ x: e.clientX, y: e.clientY }); if (locs.length > 3) locs.shift(); });
  const slope = (a, b) => (b.y - a.y) / (b.x - a.x);
  function aimDelay() {
    if (!panelsWrap || locs.length < 2) return 0;
    const r = panelsWrap.getBoundingClientRect();
    const loc = locs[locs.length - 1], prev = locs[0];
    if (loc.x >= r.left) return 0;
    if (lastDelayLoc && loc.x === lastDelayLoc.x && loc.y === lastDelayLoc.y) return 0; // stopped moving
    const top = { x: r.left, y: r.top - 80 }, bottom = { x: r.left, y: r.bottom + 80 };
    if (slope(loc, top) < slope(prev, top) && slope(loc, bottom) > slope(prev, bottom)) { lastDelayLoc = loc; return AIM_DELAY; }
    lastDelayLoc = null;
    return 0;
  }
  function hoverCat(i) {
    clearTimeout(aimTimer);
    const d = aimDelay();
    if (!d) { selectCat(i); return; }
    aimTimer = setTimeout(() => { if (cats[i].matches(":hover")) hoverCat(i); }, d);
  }
  cats.forEach((c) => c.addEventListener("mouseenter", () => { if (!isMobile()) hoverCat(Number(c.dataset.flyCat)); }));
  if (panelsWrap) panelsWrap.addEventListener("mouseenter", () => clearTimeout(aimTimer));

  function trapTab(e) {
    const focusable = $$('a[href], button:not([disabled]), input:not([type="hidden"]), [tabindex]:not([tabindex="-1"])', panel).filter((el) => el.offsetParent !== null);
    if (!focusable.length) return;
    const first = focusable[0], last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }
  document.addEventListener("keydown", (e) => {
    if (!isOpen) return;
    if (e.key === "Escape") {
      e.preventDefault();
      if (!results.hidden) { resetSearch(); input.focus(); }
      else if (isMobile() && track.classList.contains("is-level-1")) goBack();
      else close();
      return;
    }
    if (e.key === "Tab") { trapTab(e); return; }
    const cat = document.activeElement && document.activeElement.closest && document.activeElement.closest("[data-fly-cat]");
    if (!cat) return;
    if (e.key === "ArrowDown" || e.key === "ArrowUp") {
      e.preventDefault();
      const n = (Number(cat.dataset.flyCat) + (e.key === "ArrowDown" ? 1 : -1) + cats.length) % cats.length;
      cats[n].focus();
      if (!isMobile()) selectCat(n);
    } else if (e.key === "ArrowRight" && !isMobile()) {
      const first = panels[active] && panels[active].querySelector("a");
      if (first) { e.preventDefault(); first.focus(); }
    }
  });
  mq.addEventListener("change", () => { track.classList.remove("is-level-1"); });

  // deep links for QA and support: /#fly-menu opens the drawer, /#fly-search opens it on the search field
  if (location.hash === "#fly-menu") open("menu");
  else if (location.hash === "#fly-search") open("search");

  window.FlyoutNav = { open, close, select: selectCat };
})();
